export const media = {
  types: {
    pdf: "PDF dokumentum",
    audio: "Hangfájl",
    video: "Videó",
    image: "Kép",
    ebook: "E-könyv",
    document: "Dokumentum",
    archive: "Tömörített fájl",
    package: "Csomag",
    unknown: "Ismeretlen fájl",
  },
  actions: {
    download: "Letöltés",
    downloading: "Letöltés...",
    view: "Megtekintés",
    play: "Lejátszás",
    open: "Megnyitás",
  },
  fileSize: {
    kb: "KB",
    mb: "MB",
    gb: "GB",
  },
  labels: {
    filename: "Fájlnév",
    fileType: "Típus",
    fileSize: "Méret",
    contentMaterials: "Tartalmi anyagok",
    file: "fájl",
    files: "fájlok",
  },
  messages: {
    accessAfterPurchase:
      "A tartalom megvásárlása után férhetsz hozzá az összes fájlhoz.",
  },
};
